import React from "react";
import Navbar from "../components/Navbar";
import { Footer } from "../components/footer";
import TryYourFieldExperience from "../components/tryfield/TryYourFieldExperience";
import useDocumentMeta from "../hooks/useDocumentMeta";

/**
 * /try-your-field — PRD-01. A hands-on, no-sign-up preview: drop a pin on
 * Egypt and see weather + crop water demand for your own land.
 */
export default function TryYourField({ lang = "EN", toggleLanguage }) {
  const isAr = lang === "AR";

  useDocumentMeta({
    title: isAr
      ? "جرّب فارمتوبيا على حقلك — معاينة فورية"
      : "Try FarmTopia on Your Own Field — Instant Preview",
    description: isAr
      ? "أسقط دبوسًا على حقلك في مصر وشاهد الطقس واحتياج المحصول المائي فورًا — دون تسجيل."
      : "Drop a pin on your field in Egypt and see the weather and your crop's water demand instantly — no sign-up.",
  });

  return (
    <div dir={isAr ? "rtl" : "ltr"} className="bg-gray-50 min-h-screen">
      <Navbar lang={lang} toggleLanguage={toggleLanguage} />
      <main className="max-w-6xl mx-auto px-4 py-10">
        {/* Hook */}
        <header className="max-w-2xl">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            {isAr ? "شوف حقلك بعين فارمتوبيا" : "See your field through FarmTopia"}
          </h1>
          <p className="mt-3 text-gray-600">
            {isAr
              ? "أسقط دبوسًا في أي مكان في مصر، وسنعرض لك الطقس واحتياج محصولك المائي فورًا — قبل أي تسجيل."
              : "Drop a pin anywhere in Egypt, and we'll show you the weather and your crop's water demand instantly — before you sign up for anything."}
          </p>
        </header>

        {/* Experience */}
        <section className="mt-8">
          <TryYourFieldExperience lang={lang} />
        </section>
      </main>
      <Footer lang={lang} />
    </div>
  );
}
